(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/promos/views/default-promos.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/promos/views/default-promos.js');

'use strict';

svs.app.productStartPage.promos.views.DefaultPromos = Marionette.CollectionView.extend({
  className: 'grid-row',
  childView: svs.app.productStartPage.promos.views.DefaultPromo,
  template: function(data) {
    return svs.app.product_start_page.templates.default_promos(data);
  },
  childViewOptions: function(model, index) {
    return {
      itemIndex: index
    };
  },
  onRender: function() {
    if (this.model.get('branding')) {
      this.$el.addClass('default-promos default-promos-' + this.model.get('branding'));
    }
  }
});



 })(window);